module.exports = __webpack_public_path__ + "static/img/not_start.0a77c1df.png";